import { Col, Row, Typography } from "antd";

export interface SatageSubHeaderProps {
  readonly stepsList: React.ReactNode;
  readonly overviewText: React.ReactNode;
}

// PD-02 Stage pages sub-header. Overview on the left, steps on the right.
// Branded teal accent line under each section title via `.stage-subheader-accent`.
function SatageSubHeader(props: SatageSubHeaderProps) {
  return (
    <Row
      className="animate__animated animate__fadeIn flex flex-row flex-wrap justify-center gap-12 p-7"
      style={{
        background:
          "linear-gradient(180deg, rgba(232,246,245,0.5) 0%, rgba(242,242,242,0.7) 100%)",
      }}
    >
      <Col className="flex w-96 max-w-full flex-col gap-2">
        <Typography.Title
          level={2}
          className="stage-subheader-accent mb-2 text-4xl tracking-tight !text-[#0d7a73]"
        >
          Overview
        </Typography.Title>
        <Typography.Paragraph className="text-justify text-lg leading-relaxed tracking-wide">
          {props.overviewText}
        </Typography.Paragraph>
      </Col>
      <Col className="flex w-[32rem] max-w-full flex-col gap-2">
        <Typography.Title
          level={2}
          className="stage-subheader-accent mb-2 text-4xl tracking-tight !text-[#0d7a73]"
        >
          Steps
        </Typography.Title>
        <ul className="m-0 list-none p-0 text-lg leading-relaxed tracking-wide">
          {props.stepsList}
        </ul>
      </Col>
    </Row>
  );
}

export default SatageSubHeader;
